// extracted by mini-css-extract-plugin
module.exports = {"headingWrap":"_2QAl6","whyCARS24":"_10abY","bottomTestimonial":"M-__2","wrongMethod":"_3gIZu","innerDiv":"_3eTSH","paddingRight":"_1owqh","sellCarWrap":"_3adWS"};